/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-09 15:58:51 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-10-10 17:01:27
 */
import client from './client';

export default {
  getList: (data) => {
    return client.get('commissions/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  statistic: (data) => {
    return client.get('commissions/statistic?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  getLogList: (data) => {
    return client.get('commissions/log/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  saveNote: data => {
    return client.post('commissions/update/note', data).then(res => res.data)
  }
}